'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _setPropTypes = require('recompose/setPropTypes');

var _setPropTypes2 = _interopRequireDefault(_setPropTypes);

var _interceptUpdater = require('coact-utils/interceptUpdater');

var _interceptUpdater2 = _interopRequireDefault(_interceptUpdater);

var _omitProps = require('coact-utils/omitProps');

var _omitProps2 = _interopRequireDefault(_omitProps);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var func = _propTypes2.default.func;

var enhancer = (0, _compose2.default)((0, _setPropTypes2.default)({
  parser: func,
  onChange: func.isRequired
}),

// ISSUE add defaut parser before custom parser
// like invisible to `null`, to avoid user handle it incorrectly
(0, _interceptUpdater2.default)('onChange', 'parser'), (0, _omitProps2.default)(['parser']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'applyParser');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/applyParser.js
// module id = 1675
// module chunks = 0